import { useEffect, useState } from 'react';

/**
 * @mantine/form 组件有一个问题，没办法实现在表单数据变更后立即保存表单数据
 *
 * 因为在表单项 onChange 事件中没办法拿到最新的表单数据，即： form.values 里的数据是旧的数据。
 * 原因是可以理解的，因为应该 form.getInputProps('xxxx').onChange() 里更新数据是异步操作。
 * 所以立即调用 form.values 或者 form.submit() 拿不到最新的数据。
 *
 * P.S. 奇怪的是，我这么写也拿不到最新数据
 * setTimeout(()=>{
 *  console.log('form.values', form.values);
 * }, 1000);
 *
 * 但如果把 form.values 或者 form.submit() 代码放到 useEffect 里，就可以拿到最新数据。
 *
 * 因此，用这个思路实现了这个 hook
 *
 * @param submit form.onSubmit((values) => console.log(values)) 或者其他任意函数，在这个函数里可以拿到最新的表单数据
 * @returns 触发「参数函数」的函数
 */
export const useSubmitFormAsync = (submit: () => void) => {
  const [triggerCount, setTriggerCount] = useState(0);

  useEffect(() => {
    // 组件渲染，会调用第一次触发时，不保存
    if (!triggerCount) return;
    submit();
  }, [triggerCount]);

  const submitInNextTick = () => {
    setTriggerCount(triggerCount + 1);
  };

  return submitInNextTick;
};
